import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class DispositionResult {
    private json: any;
    private caseIssueId: string;
    // private dispositionDate:string;
    private parentArray: Parent[] = [];
    private otherAllegations: any = [];

    private isOrderLevel1FlagPresent = false;
    private isOrderLevel2FlagPresent = false;
    private isOrderOtherFlagPresent = false;


    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        // this.dispositionDate = dispositionDate;
        this.populateParents();
        // this.populateDispositionDelinquent();
        this.populateOtherAllegations();
    }

    populateParents() {
        let obj: any = SafeJSON.get('parents', this.json);
        let index = '0';
        for (const parent of obj) {
            let value = new Parent(parent, index);
            this.parentArray.push(value);
        }
    }

    getParents(): any {
        this.parentArray.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parentArray;
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getDispositionDelinquentHistoryLevel() {
        let lvlCode: string = SafeJSON.get('dispositionDelinquent.historyLevel', this.json);

        if (lvlCode === 'L') {
            return 'Low';
        }

        if (lvlCode === 'M') {
            return 'Medium';
        }

        if (lvlCode === 'H') {
            return 'High';
        }

        return '';
    }

    getPredispositionReportFlag() {
        return SafeJSON.get('dispositionDelinquent.preDisposition', this.json);
    }

    getRiskAssessmentFlag() {
        return SafeJSON.get('dispositionDelinquent.riskAssessmentInd', this.json);
    }

    getNeedsAssessmentFlag() {
        return SafeJSON.get('dispositionDelinquent.needsAssessmentInd', this.json);
    }

    getDispositionDelinquentCourtConsidered() {
        let value = '';
        // if(SafeJSON.get('dispositionDelinquent.preDisposition', this.json) !== '-') {
        let flag: string = SafeJSON.get('dispositionDelinquent.preDisposition', this.json);

        if (flag === 'Y') {
            value = 'predisposition report';
        }
        // }

        // if(SafeJSON.get('dispositionDelinquent.riskAssessmentInd', this.json) !== '-') {
        flag = SafeJSON.get('dispositionDelinquent.riskAssessmentInd', this.json);

        if (value !== '') {
            if (flag === 'Y') {
                value = value + ', ' + 'risk assessment';
            }
        } else {
            if (flag === 'Y') {
                value = value + 'risk assessment';
            }
        }
        // }

        // if(SafeJSON.get('dispositionDelinquent.needsAssessmentInd', this.json) !== '-') {
        flag = SafeJSON.get('dispositionDelinquent.needsAssessmentInd', this.json);

        if (value !== '') {
            if (flag === 'Y') {
                value = value + ', ' + 'needs assessment';
            }
        } else {
            if (flag === 'Y') {
                value = value + 'needs assessment';
            }
        }
        // }
        return value;
    }

    getDispositionDelinquentIncorporateContent(): string {
        let value = '';
        // if(SafeJSON.get('dispositionDelinquent.incoporateContents', this.json) !== '-') {
        let flag: string = SafeJSON.get('dispositionDelinquent.incoporateContents', this.json);

        if (flag === 'Y') {
            value = 'predisposition report';
        }
        // }

        // if(SafeJSON.get('dispositionDelinquent.includeRiskAssessmentInd', this.json) !== '-') {
        flag = SafeJSON.get('dispositionDelinquent.includeRiskAssessmentInd', this.json);

        if (value !== '') {
            if (flag === 'Y') {
                value = value + ', ' + 'risk assessment';
            }
        } else {
            if (flag === 'Y') {
                value = value + 'risk assessment';
            }
        }
        // }

        // if(SafeJSON.get('dispositionDelinquent.includeNeedsAssessmentInd', this.json) !== '-') {
        flag = SafeJSON.get('dispositionDelinquent.includeNeedsAssessmentInd', this.json);

        if (value !== '') {
            if (flag === 'Y') {
                value = value + ', ' + 'needs assessment by reference.';
            }
        } else {
            if (flag === 'Y') {
                value = value + 'needs assessment by reference';
            }
        }
        // }
        return value;
    }

    getOtherFindings(): string {
        return SafeJSON.get('otherFindings', this.json);
    }

    getConclusionsOfLawFlag() {
        let levelOfDisposition: string = SafeJSON.get('dispositionDelinquent.levelOfDisposition', this.json);

        if (levelOfDisposition === 'L1') {
            return 'Level 1 disposition';
        }

        if (levelOfDisposition === 'L2') {
            return 'Level 2 disposition (and also may order any level 1 disposition)';
        }

        if (levelOfDisposition === 'L12') {
            return 'Level 1 disposition or a Level 2 disposition, or both.';
        }

        if (levelOfDisposition === 'L23') {
            // tslint:disable-next-line:max-line-length
            return 'Because of the juvenile\'s extraordinary needs, the Court is authorized to order a Level 2 disposition rather than a Level 3 disposition, which otherwise would be required in this case.';
        }
        return levelOfDisposition;
    }

    getProbationIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.probationIndicator', this.json);
    }

    getProbationDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.probationDuration', this.json);
    }

    getHomeSupervisionIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.homeSupervisionIndicator', this.json);
    }

    getHomeSupervisorName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.homeSupervisorName', this.json);
    }

    getSupervisionConditions(): string {
        return SafeJSON.get('supervisionConditions', this.json);
    }

    getCustodyChangeIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.custodyChangeIndicator', this.json);
    }

    getParentCustodyIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.parentCustodyIndicator', this.json);
    }

    getChangedParentName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.changedParentName', this.json);
    }

    getMotherCustodyIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.motherCustodyIndicator', this.json);
    }

    getChangedMotherName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.changedMotherName', this.json);
    }

    getFatherCustodyIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.fatherCustodyIndicator', this.json);
    }
    getChangedFatherName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.changedFatherName', this.json);
    }

    getOtherCustodyIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.otherCustodyIndicator', this.json);
    }

    getChangedOtherName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.changedOtherName', this.json);
    }

    getCountySSCustodyIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.countySSCustodyIndicator', this.json);
    }

    getChangedCountySSName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.changedCountySSName', this.json);
    }

    getExcuseFromSchoolIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.excuseFromSchoolIndicator', this.json);
    }

    getExcuseConditions(): string {
        return SafeJSON.get('excuseConditions', this.json);
    }

    getCoopWithSpecifiedProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.coopWithSpecifiedProgramIndicator', this.json);
    }

    getCoopWithSpecifiedProgramDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.coopWithSpecifiedProgramDuration', this.json);
    }

    getCommunityProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.communityProgramIndicator', this.json);
    }

    getCommunityProgramName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.communityProgramName', this.json);
    }

    getSubstanceAbuseProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.substanceAbuseProgramIndicator', this.json);
    }

    getSubstanceAbuseProgramName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.substanceAbuseProgramName', this.json);
    }

    getResidentialProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.residentialProgramIndicator', this.json);
    }

    getResidentialProgramName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.residentialProgramName', this.json);
    }

    getNonResidentialProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.nonResidentialProgramIndicator', this.json);
    }

    getNonResidentialProgramName(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.nonResidentialProgramName', this.json);
    }

    getLevel1RestitutionIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1RestitutionIndicator', this.json);
    }

    getLevel1RestitutionAmount(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1RestitutionAmount', this.json);
    }

    getLevel1RestitutionPayee(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1RestitutionPayee', this.json);
    }

    getLevel1RestitutionDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1RestitutionDuration', this.json);
    }

    getLevel1RestitutionConditions(): string {
        return SafeJSON.get('level1RestitutionConditions', this.json);
    }

    getFinePayIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.finePayIndicator', this.json);
    }

    getFinePayAmount(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.finePayAmount', this.json);
    }

    getLevel1CommunityService(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1CommunityService', this.json);
    }

    getLevel1CommunityServiceDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1CommunityServiceDuration', this.json);
    }

    getLevel1CommunityConditions(): string {
        return SafeJSON.get('level1CommunityConditions', this.json);
    }

    getVictimOffenderReconcileIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.victimOffenderReconcileIndicator', this.json);
    }

    getNoDrivingLicenseIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.noDrivingLicenseIndicator', this.json);
    }

    getNoDrivingLicenseForJurisIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.noDrivingLicenseForJurisIndicator', this.json);
    }

    getNoDrivingLicenseDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.noDrivingLicenseDuration', this.json);
    }

    getCurfewIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.curfewIndicator', this.json);
    }

    getCurfewConditions(): string {
        return SafeJSON.get('curfewConditions', this.json);
    }

    getNoPersonAssocIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.noPersonAssocIndicator', this.json);
    }

    getNotAssociatePersonsConditions(): string {
        return SafeJSON.get('notAssociatePersonsConditions', this.json);
    }

    getNoPresencePlaceIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.noPresencePlaceIndicator', this.json);
    }

    getNotInPlacesConditions(): string {
        return SafeJSON.get('notInPlacesConditions', this.json);
    }

    getLevel1IntermittantConfinementIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1IntermittantConfinementIndicator', this.json);
    }

    getLevel1ConfinementConditions(): string {
        return SafeJSON.get('level1ConfinementConditions', this.json);
    }

    getLevel1WildernessProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelOne.level1WildernessProgramIndicator', this.json);
    }

    getWildernessProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.wildernessProgramIndicator', this.json);
    }

    getPlacementProgramCoopIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.placementProgramCoopIndicator', this.json);
    }

    getPlacementProgramCode() {
        return SafeJSON.get('dispositionDelinquentLevelTwo.placementProgramCode', this.json);
        /*  let placementProgramCode:string = SafeJSON.get('dispositionDelinquentLevelTwo.placementProgramCode', this.json);

         if(placementProgramCode === 'RTF') {
             return 'a residential treatment facility';
         }

         if(placementProgramCode === 'NRT') {
             return 'an intensive nonresidential treatment program';
         }

         if(placementProgramCode === 'SAP') {
             return 'an intensive substance abuse program';
         }

         if(placementProgramCode === 'SMP') {
             return 'a group home other than a multipurpose group home operated by a State agency.';
         }

         return ''; */
    }

    getProgramDescription(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.programDescription', this.json);
    }

    getProgramDescriptionRTF(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.programDescriptionRTF', this.json);
    }

    getProgramDescriptionNRT(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.programDescriptionNRT', this.json);
    }

    getProgramDescriptionSAP(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.programDescriptionSAP', this.json);
    }

    getProgramDescriptionSMP(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.programDescriptionSMP', this.json);
    }

    getIntensiveProbationIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.intensiveProbationIndicator', this.json);
    }

    getSupervisedDayProgramIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.supervisedDayProgramIndicator', this.json);
    }

    getRegimentedTrainingIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.regimentedTrainingIndicator', this.json);
    }

    getRegimentedTrainingProgConditions(): string {
        return SafeJSON.get('regimentedTrainingProgConditions', this.json);
    }

    getHouseArrestIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.houseArrestIndicator', this.json);
    }

    getHouseArrestConditions(): string {
        return SafeJSON.get('houseArrestConditions', this.json);
    }

    getIntermittantConfinementIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.intermittantConfinementIndicator', this.json);
    }

    getLevel2ConfinementConditions(): string {
        return SafeJSON.get('level2ConfinementConditions', this.json);
    }

    getStateMultiPurposeGroupHomeIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.stateMultiPurposeGroupHomeIndicator', this.json);
    }

    getLevel2RestitutionIndicator(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2RestitutionIndicator', this.json);
    }

    getLevel2RestitutionAmount(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2RestitutionAmount', this.json);
    }

    getLevel2RestitutionPayee(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2RestitutionPayee', this.json);
    }

    getLevel2RestitutionDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2RestitutionDuration', this.json);
    }

    getLevel2RestitutionConditions(): string {
        return SafeJSON.get('level2RestitutionConditions', this.json);
    }

    getLevel2CommunityService(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2CommunityService', this.json);
    }

    getLevel2CommunityServiceDuration(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.level2CommunityServiceDuration', this.json);
    }

    getLevel2CommunityConditions(): string {
        return SafeJSON.get('level2CommunityConditions', this.json);
    }

    getSuspendMoreSevereDisposition(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.suspendMoreSevereDisposition', this.json);
    }

    getDispositionListByPara(): string {
        return SafeJSON.get('dispositionDelinquentLevelTwo.dispositionListByPara', this.json);
    }

    getSuspSevereDispConditions(): string {
        return SafeJSON.get('suspSevereDispConditions', this.json);
    }

    getFamilyPlanIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.familyPlanIndicator', this.json);
    }

    getFamilyPlanDuration(): string {
        return SafeJSON.get('dispositionDelinquentOther.familyPlanDuration', this.json);
    }

    getFamilyPlanConditions(): string {
        return SafeJSON.get('familyPlanConditions', this.json);
    }

    getExamByExpertIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.examByExpertIndicator', this.json);
    }

    getExamByExpertNameType(): string {
        return SafeJSON.get('dispositionDelinquentOther.examByExpertNameType', this.json);
    }

    getExamByExpertDate(): string {
        return SafeJSON.get('dispositionDelinquentOther.examByExpertDate', this.json);
    }

    getIndisciplineEvaluation(): string {
        return SafeJSON.get('dispositionDelinquentOther.indisciplineEvaluation', this.json);
    }

    getSubstanceTestIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.substanceTestIndicator', this.json);
    }

    getAlcoholTestIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.alcoholTestIndicator', this.json);
    }

    getPgcRequirementIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.pgcrequirementIndicator', this.json);
    }

    getReqtMother(): string {
        return SafeJSON.get('dispositionDelinquentOther.reqtMother', this.json);
    }

    getReqtFather(): string {
        return SafeJSON.get('dispositionDelinquentOther.reqtFather', this.json);
    }

    getReqtGuardian(): string {
        return SafeJSON.get('dispositionDelinquentOther.reqtGuardian', this.json);
    }

    getReqtCustodian(): string {
        return SafeJSON.get('dispositionDelinquentOther.reqtCustodian', this.json);
    }

    getNextHearingDate(): string {
        return SafeJSON.get('dispositionDelinquentOther.nextHearingDate', this.json);
    }

    getOtherOrderIndicator(): string {
        return SafeJSON.get('dispositionDelinquentOther.otherOrderIndicator', this.json);
    }

    getOtherConditions(): string {
        return SafeJSON.get('otherConditions', this.json);
    }

    chkOrderOtherDetialsPresent(): boolean {
        if ((this.getFamilyPlanIndicator() !== '') || (this.getFamilyPlanDuration() !== '') || (this.getFamilyPlanConditions() !== '')
            || (this.getExamByExpertIndicator() !== '') || (this.getExamByExpertNameType() !== '') || (this.getExamByExpertDate() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getIndisciplineEvaluation() !== '') || (this.getSubstanceTestIndicator() !== '') || (this.getAlcoholTestIndicator() !== '')
            || (this.getPgcRequirementIndicator() !== '') || (this.getReqtMother() !== '') || (this.getReqtFather() !== '')
            || (this.getReqtGuardian() !== '') || (this.getReqtCustodian() !== '') || (this.getNextHearingDate() !== '')
            || (this.getOtherOrderIndicator() !== '') || (this.getOtherConditions() !== '')) {
            this.isOrderOtherFlagPresent = true;
        }
        return this.isOrderOtherFlagPresent;
    }

    chkOrderLevel1DetailsPresent(): boolean {

        if ((this.getProbationIndicator() !== '') || (this.getProbationDuration() !== '') || (this.getHomeSupervisionIndicator() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getHomeSupervisorName() !== '') || (this.getSupervisionConditions() !== '') || (this.getCustodyChangeIndicator() !== '')
            || (this.getParentCustodyIndicator() !== '') || (this.getChangedParentName() !== '') || (this.getMotherCustodyIndicator() !== '')
            || (this.getChangedMotherName() !== '') || (this.getFatherCustodyIndicator() !== '') || (this.getChangedFatherName() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getOtherCustodyIndicator() !== '') || (this.getChangedOtherName() !== '') || (this.getCountySSCustodyIndicator() !== '')
            || (this.getChangedCountySSName() !== '') || (this.getExcuseFromSchoolIndicator() !== '') || (this.getExcuseConditions() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getCoopWithSpecifiedProgramIndicator() !== '') || (this.getCoopWithSpecifiedProgramDuration() !== '') || (this.getCommunityProgramIndicator() !== '')
            || (this.getCommunityProgramName() !== '') || (this.getSubstanceAbuseProgramIndicator() !== '') || (this.getSubstanceAbuseProgramName() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getResidentialProgramIndicator() !== '') || (this.getResidentialProgramName() !== '') || (this.getNonResidentialProgramIndicator() !== '')
            || (this.getNonResidentialProgramName() !== '') || (this.getLevel1RestitutionIndicator() !== '') || (this.getLevel1RestitutionAmount() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getLevel1RestitutionPayee() !== '') || (this.getLevel1RestitutionDuration() !== '') || (this.getLevel1RestitutionConditions() !== '')
            || (this.getFinePayIndicator() !== '') || (this.getCommunityProgramIndicator() !== '') || (this.getFinePayAmount() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getLevel1CommunityService() !== '') || (this.getLevel1CommunityServiceDuration() !== '') || (this.getLevel1CommunityConditions() !== '')
            || (this.getVictimOffenderReconcileIndicator() !== '') || (this.getNoDrivingLicenseIndicator() !== '') || (this.getNoDrivingLicenseForJurisIndicator() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getNoDrivingLicenseDuration() !== '') || (this.getNoDrivingLicenseForJurisIndicator() !== '') || (this.getCurfewIndicator() !== '')
            || (this.getCurfewConditions() !== '') || (this.getNoPersonAssocIndicator() !== '') || (this.getNotAssociatePersonsConditions() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getNoPresencePlaceIndicator() !== '') || (this.getNotInPlacesConditions() !== '') || (this.getLevel1IntermittantConfinementIndicator() !== '')
            || (this.getLevel1ConfinementConditions() !== '') || (this.getLevel1WildernessProgramIndicator() !== '')) {
            this.isOrderLevel1FlagPresent = true;
        }
        return this.isOrderLevel1FlagPresent;
    }

    chkOrderLevel2DetailsPresent(): boolean {
        // tslint:disable-next-line:max-line-length
        if ((this.getWildernessProgramIndicator() !== '') || (this.getPlacementProgramCoopIndicator() !== '') || (this.getPlacementProgramCode() !== '')
            || (this.getProgramDescription() !== '') || (this.getPlacementProgramCode() !== '') || (this.getProgramDescription() !== '')
            || (this.getPlacementProgramCode() !== '') || (this.getProgramDescription() !== '') || (this.getPlacementProgramCode() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getProgramDescription() !== '') || (this.getIntensiveProbationIndicator() !== '') || (this.getSupervisedDayProgramIndicator() !== '')
            || (this.getRegimentedTrainingIndicator() !== '') || (this.getRegimentedTrainingProgConditions() !== '') || (this.getHouseArrestIndicator() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getHouseArrestConditions() !== '') || (this.getIntermittantConfinementIndicator() !== '') || (this.getLevel2ConfinementConditions() !== '')
            || (this.getStateMultiPurposeGroupHomeIndicator() !== '') || (this.getLevel2RestitutionIndicator() !== '') || (this.getLevel2RestitutionAmount() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getLevel2RestitutionPayee() !== '') || (this.getLevel2RestitutionDuration() !== '') || (this.getLevel2RestitutionConditions() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getLevel2CommunityService() !== '') || (this.getLevel2CommunityServiceDuration() !== '') || (this.getLevel2CommunityConditions() !== '')
            // tslint:disable-next-line:max-line-length
            || (this.getSuspendMoreSevereDisposition() !== '') || (this.getDispositionListByPara() !== '') || (this.getSuspSevereDispConditions() !== '')) {
            this.isOrderLevel2FlagPresent = true;
        }
        return this.isOrderLevel2FlagPresent;
    }

    isOrderLevel1DetailsPresent(): boolean {
        return this.chkOrderLevel1DetailsPresent();
    }

    isOrderLevel2DetailsPresent(): boolean {
        return this.chkOrderLevel2DetailsPresent();
    }

    isOrderOtherDetialsPresent(): boolean {
        return this.chkOrderOtherDetialsPresent();
    }

    isOrderDetailsPresent(): boolean {
        return (this.chkOrderLevel1DetailsPresent() || this.chkOrderLevel2DetailsPresent() || this.chkOrderOtherDetialsPresent());
    }


    getDispositionDate(): string {
        return SafeJSON.get('dispositionDate', this.json);
    }

    getDispositionEoDate(): string {
        return SafeJSON.get('dispositionEoDate', this.json);
    }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/disposition-result.ts